import { icon } from '@carvana/ds-styles';
import { Clickable } from '@carvana/merch-components';
import { SearchSource } from '@carvana/merch-contracts';
import { Info } from 'lucide-react';
import { useContext } from 'react';
import { appAssetsCdnUrl } from '~/constants/environment';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import AppliedFiltersContext from '~/context/common/AppliedFiltersContext';
import { useConfiguration } from '~/context/common/StaticContext';
import { useModalContext } from '~/context/srp/ModalContext/ModalContext';
import SearchEventsDataContext from '~/context/srp/SearchEventsDataContext';
import ConditionalTile from './ConditionalTile';

type OwnProps = {
  position: number;
};

export default function GreatDealTile({ position }: OwnProps) {
  const { shouldUseTitleCasing } = useConfiguration();
  const { setGreatDealModalOpen } = useModalContext();
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const { setAppliedFilters } = useContext(AppliedFiltersContext);
  const trackEvent = useTrackEvent();

  return (
    <ConditionalTile
      anchorProps={{
        href: '#',
        id: 'GreatDealTile',
        onClick: ev => {
          ev.preventDefault();
          ev.stopPropagation();

          setAppliedFilters({
            tagIds: ['104']
          });
          setSearchSource(SearchSource.Tile);

          trackEvent('Conditional Tile', {
            action: 'clicked',
            tile: 'GreatDealTile',
            position
          });
        }
      }}
      classes={{
        content: 'px-md'
      }}
      ctaCopy={shouldUseTitleCasing ? 'Shop Now' : 'Shop now'}
      description="Browse cars that save you $1,500 or more vs. Kelley Blue Book® Typical Listing Price."
      imageProps={{
        src: `${appAssetsCdnUrl}/images/heliosConditionalTiles/greatdeals-illustration.png`,
        alt: 'Great Deal'
      }}
      position={position}
      tileName="GreatDealTile"
      title={
        <span>
          Save $1,500+ with these great deals{' '}
          <Clickable
            aria-label="Learn more about great deals"
            className="inline-flex align-middle"
            data-adobe-id="great-deal-tile-learn-more"
            data-analytics-id="Great Deal Tile - Learn More"
            data-testid="great-deal-info-button"
            element="span"
            onClick={ev => {
              ev.stopPropagation();
              setGreatDealModalOpen(true);
            }}
          >
            <Info
              aria-hidden="true"
              data-testid="great-deal-info"
              size={16}
              color={icon.strong}
            />
          </Clickable>
        </span>
      }
    />
  );
}
